import { createFileRoute, Navigate } from '@tanstack/react-router'

/** Retailer costs are a tab of Costs, as in VentaHub; old links land there. */
export const Route = createFileRoute('/_app/data-vault/retailer-costs')({
  component: () => (
    <Navigate to="/data-vault/costs" search={{ costType: 'retailer', tab: 'view' }} replace />
  ),
})
